<template>
    <DataTable :value="products" tableStyle="min-width: 50rem">
        <Column field="code" header="Code"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="category" header="Category"></Column>
        <Column field="quantity" header="Quantity"></Column>
    </DataTable>
</template>
<script setup>
    import { ref, onMounted } from 'vue';
    // import { ProductService } from '@/service/ProductService';
    //
    // onMounted(() => {
    //     ProductService.getProductsMini().then((data) => (products.value = data));
    // });

    const products = ref([
        {
            code : '1',
            name : '1',
            category : '1',
            quantity : '1',
        }
    ]);
</script>
